var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDienstleistungen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Dienstleistungen__Icn/40px/Legende/Dienstleistungen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Dienstleistungen__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Dienstleistungen__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,9.62585449 L28.9842736,14.8129272 L28.9842736,25.1870728 L20,30.3741455 L11.0157264,25.1870728 L11.0157264,14.8129272 L20,9.62585449 Z M20,11.934 L13.015,15.967 L13.015,24.032 L20,28.065 L26.984,24.032 L26.984,15.967 L20,11.934 Z M20,15 C22.7614237,15 25,17.2385763 25,20 C25,22.7614237 22.7614237,25 20,25 C17.2385763,25 15,22.7614237 15,20 C15,17.2385763 17.2385763,15 20,15 Z M20,17 C18.3431458,17 17,18.3431458 17,20 C17,21.6568542 18.3431458,23 20,23 C21.6568542,23 23,21.6568542 23,20 C23,18.3431458 21.6568542,17 20,17 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Dienstleistungen__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDienstleistungen);
export default __webpack_public_path__ + "static/media/Dienstleistungen.6c0d1d0021524e1146add320324a44c0.svg";
export { ForwardRef as ReactComponent };